<template>
    <div class="stock-analysis">
        <OptionCard :info="{ title: '库存分析', desc: `${pageParams.startDateTime}~${pageParams.endDateTime}`, label: pageParams.dateLabel}" :actions="['refresh']" @refresh="refresh">
            <el-row>
                <InventorySummary ref="inventorySummary" />
            </el-row>
            <el-row :gutter="12" class="form-line-table">
                <el-col :span="14" :xl="14" :lg="12" v-loading="line.loading"  class="col-line">
                    <ve-line ref="vchart" :events="line.chartEvents" :legend-visible="false" :extend="line.extend" :settings="line.settings" :data="line.data"></ve-line>
                </el-col>
                <el-col :span="10" :xl="10" :lg="12" class="add-estimate">
                    <div style="overflow: auto;">
                        <el-form v-loading="storageAnalysisGetSmart.loading" style="width: 650px">
                        <el-row type="flex">
                            <el-col :span="10">
                                <el-form-item label="日均消耗量：" class="average-per-day">
                                    <gj-select
                                        @change="changeAverage"
                                        v-model="storageAnalysisGetSmart.consumeDay"
                                        :options="averagePerday"
                                        width="90px"
                                        :clearable="false"
                                    ></gj-select>
                                    <gj-input
                                        :clearable="false"
                                        maxlength="8"
                                        @change="changeQuantity"
                                        v-model="storageAnalysisGetSmart.consumeQuantity"
                                        width="60px"
                                        placeholder=""
                                        :disabled="storageAnalysisGetSmart.consumeDay != 0"
                                    ></gj-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item label="安全库存天数：">
                                    <gj-input
                                        maxlength="4"
                                        v-checkInteger:safeStorageDay="{value: storageAnalysisGetSmart.safeStorageDay, obj: storageAnalysisGetSmart}"
                                        @change="changeEstimateSafeStorageDay"
                                        @input="inputSafeStorageDay"
                                        v-model="storageAnalysisGetSmart.safeStorageDay"
                                        width="80px"
                                    ></gj-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item label="采购交期：" class="sign-form">
                                    <gj-input
                                        v-checkInteger:purchaseDeliveryDays="{value: storageAnalysisGetSmart.purchaseDeliveryDays, obj: storageAnalysisGetSmart}"
                                        maxlength="4"
                                        @change="changeEstimatePurchaseDeliveryDays"
                                        v-model="storageAnalysisGetSmart.purchaseDeliveryDays"
                                        width="80px"
                                    ></gj-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row type="flex">
                            <el-col :span="10">
                                <el-form-item label="目标库存量：">
                                    <gj-input
                                        maxlength="8"
                                        v-checkInteger:targetStorageQuantity="{value: storageAnalysisGetSmart.targetStorageQuantity, obj: storageAnalysisGetSmart}"
                                        @change="changeTargetStorageQuantity"
                                        @input="drawZoom"
                                        v-model="storageAnalysisGetSmart.targetStorageQuantity"
                                        width="150px"
                                    ></gj-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item label="目标库存天数：">
                                    <gj-input
                                        maxlength="4"
                                        v-checkInteger:targetStorageDay="{value: storageAnalysisGetSmart.targetStorageDay, obj: storageAnalysisGetSmart}"
                                        @change="changeTargetStorageDay"
                                        v-model="storageAnalysisGetSmart.targetStorageDay"
                                        width="80px"
                                    ></gj-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="7"></el-col>
                        </el-row>
                    </el-form>
                    </div>
                    <EstimateList :dataZoomMap="dataZoomMap" :storageAnalysisGetSmart="storageAnalysisGetSmart" ref="estimateList" :transportOption="transportOption" :tabList="line.data.rows" @estimateChange="estimateChange" @handleSelectionChange="handleSelectionChange"/>
                </el-col>
            </el-row>
            <!-- tabs -->
            <app-top-tabs :tabs="tabs" class="stock-tabs" :tabSolid="false">
                <template #inventoryDetails>
                    <InventoryDetails ref="inventoryDetails" />
                </template>
                <template #documentDetails>
                    <DocumentDetails ref="documentDetails" />
                </template>
                <template #inventoryAccepted>
                    <InventoryAccepted ref="inventoryAccepted" />
                </template>
                <template #detailsShipment>
                    <DetailsShipment ref="detailsShipment" />
                </template>
            </app-top-tabs>
        </OptionCard>
    </div>
</template>

<script>
    import { DATA_CHARTS, DATE_ENUMS } from "modules/statistics/asin-361-analysis/config";
    import OptionCard from 'components/option-card/option-card'
    import {isMeaningfulMixin, queryMixin, selectionMixin} from "@/minxins";
    import InventoryDetails from "./components/inventory-details.vue";
    import InventoryAccepted from "./components/inventory-accepted.vue";
    import DocumentDetails from "./components/document-details.vue";
    import DetailsShipment from "./components/details-shipment.vue";
    import InventorySummary from "./components/inventory-summary.vue";
    import EstimateList from "./components/estimate-list.vue";
    import { convertToDate } from "@/utils/date.util.js"
    import { getStorageAnalysisGetSmart, storageAnalysisUpdateSmart, storageAnalysisSmartReplenishment, getTransportSelect, storageAnalysisAddEstimate } from "@/api/statistics";
    import _ from "lodash";
    export default {
        name: "statistics-stock-analysis",
        mixins: [queryMixin, selectionMixin, isMeaningfulMixin],
        inject: ['getPageParams', 'generatorPageParams'],
        computed: {
            pageParams () {
                return this.getPageParams()
            },
        },
        watch: {
            // 目标库存量
            "storageAnalysisGetSmart.targetStorageQuantity"(val) {
                this.line.extend.series.markLine.data[1].yAxis = val
            },
            // 安全库存量
            "storageAnalysisGetSmart.safeStorageQuantity"(val) {
                this.line.extend.series.markLine.data[0].yAxis = val
                this.line.extend.visualMap.pieces[1].lte = val
            },
        },
        data () {
            return {
                DATA_CHARTS,
                DATE_ENUMS,
                estimate: [],
                originalList: [], // 原始的数据
                storageAnalysisGetSmart: {
                    loading: false,
                    id: "", // 主键
                    consumeDay: 3, // 日均消耗天数
                    consumeQuantity: "", // 日均消耗量
                    prescriptionId: "", // 时效ID
                    purchaseDeliveryDays: "", // 采购交期
                    safeStorageDay: "", // 安全库存天数
                    targetStorageDay: "", // 目标库存天数
                    targetStorageQuantity: "", // 目标库存量
                    safeStorageQuantity: 0, // 安全库存量
                    transportId: "", // 物流方式ID
                    transportIdPrescriptionId: ""
                },
                dataZoomMap : {
                    startValue: convertToDate(new Date()),
                    endValue: convertToDate(new Date().getTime() + 86400000 * 90),
                },
                averagePerday: [
                    {
                        id: 3,
                        text: "3天日均"
                    },
                    {
                        id: 7,
                        text: "7天日均"
                    },
                    {
                        id: 14,
                        text: "14天日均"
                    },
                    {
                        id: 30,
                        text: "30天日均"
                    },
                    {
                        id: 0,
                        text: "自定义"
                    },
                ],
                transportOption: [], // 物流方式list
                line: {
                    loading: false,
                    data: {
                        columns: ['smartDate', 'fullFillAbleQuantity'],
                        rows: []
                    },
                    settings: {},

                    extend: {
                        yAxis: {
                            splitLine: {
                                lineStyle: {
                                    color: '#ccc',
                                    type: 'dashed'
                                }
                            },
                            axisLabel: { //坐标轴样式
                                textStyle: {
                                    color: '#636363'
                                }
                            }
                        },
                        tooltip: {
                            backgroundColor:'rgba(25,43,71,0.9)',
                            formatter : (params) => {
                                var item = this.line.data.rows[params[0].dataIndex]
                                let content =
                                `
                                    <divstyle="padding: 8px 0px 0px;">
                                        <div style="padding: 0px 10px;font-size: 13px;font-weight: 600;">${params[0].name}</div>
                                        <div style="padding: 0px 10px;font-size: 12px;font-weight: 600;">可售量: ${item.fullFillAbleQuantity}</div>
                                        <div style="padding: 0px 10px;font-size: 12px;">到货量: ${item.shipQuantity}</div>
                                        <div style="padding: 0px 10px;font-size: 12px;">预计消耗量: ${item.expectConsumeQuantity}</div>
                                        <div style="padding: 0px 10px;font-size: 12px;">预计可售天数: ${item.expectAvailableDay}</div>
                                        <div style="margin: 5px 10px 10px;height:1px;background: #f7f7f7;"></div>
                                        <div style="padding: 0px 0px 8px;">
                                `
                                // 表格
                                let tableDom1 =
                                `
                                <table border="0" style="border-top: 1px solid #ccc;border-left: 1px solid #ccc;margin: 0 10px;border-spacing: 0;font-size: 12px;">
                                    <tr>
                                        <th style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;padding: 3px 12px">类型</th>
                                        <th style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;padding: 3px 12px">来源</th>
                                        <th style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;padding: 3px 12px">物流方式</th>
                                        <th style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;padding: 3px 12px">数量</th>
                                    </tr>
                                `
                                let tableDom2 =
                                `
                                    <tr style="text-align: center;">
                                        <td style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;" colspan="4">无入库量</td>
                                    </tr>
                                `
                                if (item.voList && item.voList.length != 0) {
                                    tableDom2 = item.voList.reduce((str, item) => {
                                        let str1 =
                                        `
                                        <tr style="text-align: center;">
                                            <td style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;">${item.typeName || '-'}</td>
                                            <td style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;">${item.formCode || '-'}</td>
                                            <td style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;">${item.transportName || '-'}</td>
                                            <td style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;">${item.quantity || '-'}</td>
                                        </tr>
                                        `
                                        return str += str1
                                    }, "")
                                }
                                let tableDom3 =`</table>`
                                let tableDom = tableDom1 + tableDom2 + tableDom3
                                let footer =
                                `
                                </div>
                                    </div>
                                `
                                content = content + tableDom + footer
                                return content;
                            },
                        },
                        series: {
                            symbol: "none",
                            smooth: false, // 曲线变折线
                            markLine: { // 基准线
                                symbol:'none',//去掉箭头
                                silent: true,
                                label: {
                                    position: "middle",
                                    formatter: '{b}: {c}'
                                },
                                data: [
                                    {
                                        name: "安全库存量",
                                        yAxis: 1,
                                        type: "average",
                                        label: {
                                            position: "insideStartTop",
                                        },
                                        lineStyle:{
                                            color:'#555', //设置折线色颜色
                                        },
                                    },
                                    {
                                        name: "目标库存量",
                                        yAxis: 2,
                                        type: "average",
                                        lineStyle:{
                                            color:'#555', //设置折线色颜色
                                        },
                                    },
                                ]
                            }
                        },
                        dataZoom : {
                            show : true,
                            realtime : true,
                            startValue: convertToDate(new Date()),
                            endValue: convertToDate(new Date().getTime() + 86400000 * 90),
                        },
                        visualMap: {
                            show: false,
                            dimension: 1,
                            pieces: [
                                {
                                    lt: 1,
                                    color: '#710303'
                                },
                                {
                                    lt: 2000,
                                    color: '#c5da1a'
                                }
                            ],  //pieces的值由动态数据决定
                            outOfRange: {
                                color: 'green'
                            }
                        },
                      grid: {
                        left: '2%',
                        right: '4%'
                      },
                    },
                    // 折线图事件
                    chartEvents: {
                        datazoom:(params)=> {
                            let xAxis=this.$refs['vchart'].echarts.getModel().option.xAxis[0];
                            this.dataZoomMap.startValue = xAxis.data[xAxis.rangeStart]
                            this.dataZoomMap.endValue = xAxis.data[xAxis.rangeEnd]
                        },
                    },
                },
                tabs: [
                    {id: 'inventoryDetails', text: '库存明细'},
                    {id: 'documentDetails', text: '单据明细表'},
                    {id: 'inventoryAccepted', text: 'FBA已接收库存'},
                    {id: 'detailsShipment', text: 'FBA货件详情'},
                ]
            }
        },
        directives: {
            // 控制只能输入整数
            checkInteger: {
                update: (el, binding) => {
                    let params = binding.value
                    const regexp = (/[^0-9]|^0+(?!$)/g);
                    if (!params || !params.value) { return }
                    if (regexp.test(params.value)) {
                        params.obj[binding.arg] = params.value.replace(regexp, "");
                    }
                }
            }
        },
        methods: {
            // keyupNumber
            keyupNumber(key) {
                this.storageAnalysisGetSmart[key] = String(this.storageAnalysisGetSmart[key]).replace(/[^\d]/g,'');
                this.storageAnalysisGetSmart[key] = String(this.storageAnalysisGetSmart[key]).replace('.','');
                this.storageAnalysisGetSmart[key] = Number(this.storageAnalysisGetSmart[key])
            },
            // 刷新
            refresh() {
                this.getTransportSelect() // 获取物流方式
                this.getStorageAnalysisGetSmart()
                this.$refs.inventorySummary.getStorageAnalysisTotal() // 刷新库存汇总信息
                this.$refs.estimateList.storageAnalysisListEstimate() // 刷新预估到货list信息
                this.$refs.inventoryDetails.storageAnalysisStorageList() // 刷新库存明细list信息
            },
            // 获取物流方式
            async getTransportSelect() {
                let res = await getTransportSelect({isEnable: true}) || []
                this.transportOption = res.map(v => {return {id: v.id, text: v.text}})
            },
            // 添加预估到之红绿线
            handleSelectionChangeOld(val) {
                if (!this.originalList || this.originalList.length == 0) {
                    return
                }
                this.line.loading = true
                let index = 0
                // 重新控制zoom
                this.dataZoomMap.startValue && (this.line.extend.dataZoom.startValue = this.dataZoomMap.startValue)
                this.dataZoomMap.endValue && (this.line.extend.dataZoom.endValue = this.dataZoomMap.endValue)
                // 这里是重置数据
                for (let index = 0; index < this.originalList.length; index++) {
                    const element = this.originalList[index];
                    this.line.data.rows[index].expectAvailableDay = element.expectAvailableDay
                    this.line.data.rows[index].expectConsumeQuantity = element.expectConsumeQuantity
                    this.line.data.rows[index].fullFillAbleQuantity = element.fullFillAbleQuantity
                    this.line.data.rows[index].shipQuantity = element.shipQuantity
                    this.line.data.rows[index].voList = [...element.voList]
                }
                // 这里添加数据
                for (const i of this.originalList) {
                    for (const j of val) {
                        // 有添加的库存
                        if (i.smartDate == j.expectInboundDate) {
                            let row = this.line.data.rows[index] // 线的数据
                            row.fullFillAbleQuantity += Number(j.makeGoodQuantity) // 可售量
                            row.fullFillAbleQuantity = Math.ceil(row.fullFillAbleQuantity)
                            row.shipQuantity += Number(j.makeGoodQuantity) // 到货量
                            row.shipQuantity = Math.ceil(row.shipQuantity)
                            row.expectAvailableDay = Math.floor(row.fullFillAbleQuantity/row.expectConsumeQuantity) // 预计可售天数 = 可售量/预计消耗量
                            row.voList || (row.voList = [])
                            row.voList.unshift({
                                id: j.id,
                                formCode: "", // 来源
                                quantity: j.makeGoodQuantity, // 数量
                                transportName: j.transportName, // 物流方式
                                typeName: "预估", // 类型
                            })
                            // 添加以后的可售量、可售天数
                            let makeGoodQuantity = Number(j.makeGoodQuantity) // 预估添加的可售量
                            let expectAvailableDay = row.expectAvailableDay // 预估添加的可售量
                            for (let indexMap = index + 1; indexMap < this.line.data.rows.length; indexMap++) {
                                const element = this.line.data.rows[indexMap];
                                if (element.fullFillAbleQuantity <= i.expectConsumeQuantity) {
                                    // 如果可售量0 消耗添加的预估数量， 这里只能减少一次
                                    makeGoodQuantity -= Number(i.expectConsumeQuantity)
                                    if (makeGoodQuantity < 0) {
                                        makeGoodQuantity = 0
                                    }
                                }
                                element.fullFillAbleQuantity += makeGoodQuantity // 可售量
                                element.fullFillAbleQuantity = Math.ceil(element.fullFillAbleQuantity)
                                element.expectAvailableDay = expectAvailableDay - 1 // 预估天数
                                expectAvailableDay--
                                if (element.fullFillAbleQuantity < 0) {
                                    element.fullFillAbleQuantity = 0
                                }
                                if (element.expectAvailableDay < 0) {
                                    element.expectAvailableDay = 0
                                }
                            }
                        }
                    }
                    index++
                }
                // 这里是现在的勾选值
                this.estimate = [...val]
                this.line.loading = false
            },
            // 添加预估到之红绿线
            handleSelectionChange(val) {
                if (!this.originalList || this.originalList.length == 0) {
                    return
                }
                this.updateLineDataRow(val)
                // 这里是现在的勾选值
                this.estimate = [...val]
                this.line.loading = false
            },
            // 重新控制zoom
            drawZoom() {
                this.dataZoomMap.startValue && (this.line.extend.dataZoom.startValue = this.dataZoomMap.startValue)
                this.dataZoomMap.endValue && (this.line.extend.dataZoom.endValue = this.dataZoomMap.endValue)
            },
            // 更新红绿线 @params 勾选的数据
            updateLineDataRow(estimate = []) {
                // 1. 重新控制zoom
                this.drawZoom()
                // 2. 初始化重置数据
                for (let index = 0; index < this.originalList.length; index++) {
                    const element = this.originalList[index];
                    this.line.data.rows[index].expectAvailableDay = element.expectAvailableDay
                    this.line.data.rows[index].expectConsumeQuantity = element.expectConsumeQuantity
                    this.line.data.rows[index].fullFillAbleQuantity = element.fullFillAbleQuantity
                    this.line.data.rows[index].shipQuantity = element.shipQuantity
                    this.line.data.rows[index].voList = [...element.voList]
                }
                // 3. 统一加入补货
                let index = 0
                for (const i of this.originalList) {
                    for (const j of estimate) {
                        if (i.smartDate == j.expectInboundDate) { // 有添加的库存
                            let row = this.line.data.rows[index] // 线的数据
                            row.voList || (row.voList = [])
                            row.voList.unshift({
                                id: j.id,
                                formCode: "", // 来源
                                quantity: j.makeGoodQuantity, // 数量
                                transportName: j.transportName, // 物流方式
                                typeName: "预估", // 类型
                            })
                        }
                    }
                    index++
                }
                // 4. 设置当天可售量，可售天数，到货量；统一减少第二天可售量
                for (let i = 0; i < this.line.data.rows.length; i++) {
                    const element = this.line.data.rows[i];
                    const element1 = this.line.data.rows[i + 1];
                    element.expectConsumeQuantity != 0 && (element.expectAvailableDay = Math.floor(element.fullFillAbleQuantity / element.expectConsumeQuantity)) // 预计可售天数 = 可售量 / 预计消耗量
                    element.voList || (element.voList = [])
                    let total = element.voList.reduce((total, item) => {
                        total += Number(item.quantity)
                        return total
                    }, 0)
                    element.shipQuantity = total // 当天到货量
                    if (i == 0) {
                        element.fullFillAbleQuantity += total
                    }
                    if (!element1) { continue; } // 没有第二天；跳出循环
                    element1.voList || (element1.voList = [])
                    let total1 = element1.voList.reduce((total, item) => {
                        total += Number(item.quantity)
                        return total
                    }, 0)
                    element1.fullFillAbleQuantity = Math.floor(element.fullFillAbleQuantity - this.storageAnalysisGetSmart.consumeQuantity + total1)// 第二天的可售量：第一天可售量 - 日均消耗量 + 到货量
                    if (element.fullFillAbleQuantity - this.storageAnalysisGetSmart.consumeQuantity < 0 && total1 <= 0) { // 第一天可售量消耗完可售量&&第二天无补货量
                        element1.fullFillAbleQuantity = 0
                    }
                    if (element.fullFillAbleQuantity - this.storageAnalysisGetSmart.consumeQuantity < 0 && total1 > 0) { // 第一天可售量消耗完可售量&&第二天有补货量
                        element1.fullFillAbleQuantity = total1
                    }
                }
            },
            // 查询智能补货计算信息
            async getStorageAnalysisGetSmart() {
                this.storageAnalysisGetSmart.loading = true
                let params = {
                    asinCode: this.pageParams.asinCode,
                    asinType: this.pageParams.asinType
                }
                try {
                    let res = await getStorageAnalysisGetSmart(params) || {}
                    this.storageAnalysisGetSmart.id = res.id // 主键
                    this.storageAnalysisGetSmart.consumeDay = res.consumeDay // 日均消耗天数
                    this.storageAnalysisGetSmart.consumeQuantity = res.consumeQuantity // todo 日均消耗量
                    // this.storageAnalysisGetSmart.prescriptionId = res.prescriptionId // 时效ID
                    this.storageAnalysisGetSmart.purchaseDeliveryDays = res.purchaseDeliveryDays // 采购交期
                    this.storageAnalysisGetSmart.safeStorageDay = res.safeStorageDay // 安全库存天数
                    this.storageAnalysisGetSmart.targetStorageDay = res.targetStorageDay // 目标库存天数
                    this.storageAnalysisGetSmart.targetStorageQuantity = res.targetStorageQuantity // 目标库存量
                    // this.storageAnalysisGetSmart.transportId = res.transportId // 物流方式ID
                    if (res.transportId && res.prescriptionId) {
                        this.storageAnalysisGetSmart.transportIdPrescriptionId = `${res.transportId}#${res.prescriptionId}`
                    }
                    this.storageAnalysisSmartReplenishment()
                    this.storageAnalysisGetSmart.loading = false
                } catch (error) {
                    this.storageAnalysisGetSmart.loading = false
                }

            },
            // 更新智能补货计算信息
            async storageAnalysisUpdateSmart() {
                this.storageAnalysisGetSmart.loading = true
                let params = this.structureParams1()
                try {
                    let res = await storageAnalysisUpdateSmart(params)
                    this.storageAnalysisGetSmart.loading = false
                    // todo this.$message.success('保存成功');
                } catch (error) {
                    this.storageAnalysisGetSmart.loading = false
                }
            },
            // 构造更新智能补货params
            structureParams1() {
                let params = {
                    asinCode: this.pageParams.asinCode,
                    asinType: this.pageParams.asinType,
                    consumeDay: this.storageAnalysisGetSmart.consumeDay,
                    consumeQuantity: null,
                    id: this.storageAnalysisGetSmart.id,
                    prescriptionId: "",
                    purchaseDeliveryDays: this.storageAnalysisGetSmart.purchaseDeliveryDays,
                    safeStorageDay: this.storageAnalysisGetSmart.safeStorageDay,
                    targetStorageDay: this.storageAnalysisGetSmart.targetStorageDay,
                    targetStorageQuantity: this.storageAnalysisGetSmart.targetStorageQuantity,
                    transportId: "",
                }
                if (this.storageAnalysisGetSmart.consumeDay == 0) {
                    params.consumeQuantity = this.storageAnalysisGetSmart.consumeQuantity
                }
                if (this.storageAnalysisGetSmart.transportIdPrescriptionId) {
                    let arr = this.storageAnalysisGetSmart.transportIdPrescriptionId.split("#")
                    params.transportId = arr[0]
                    params.prescriptionId = arr[1]
                }
                return params
            },
            // 查询智能补货信息-红绿线
            async storageAnalysisSmartReplenishment() {
                this.line.loading = true
                // if (this.storageAnalysisGetSmart.consumeDay == 0 && !this.storageAnalysisGetSmart.consumeQuantity) {
                //     return
                // }
                try {
                    let res = await storageAnalysisSmartReplenishment(this.structureParams2())
                    this.storageAnalysisGetSmart.consumeQuantity = res.consumeQuantity
                    this.storageAnalysisGetSmart.safeStorageQuantity =  Number(res.consumeQuantity) * Number(this.storageAnalysisGetSmart.safeStorageDay)// 安全库存量
                    this.line.loading = false
                    this.originalList =  _.cloneDeep(res.dateVO)
                    this.line.data.rows = res.dateVO
                    this.updateLineDataRow() // 渲染红绿线
                } catch (error) {
                    this.line.loading = false
                }
            },
            // 构造查询预估参数
            structureParams2() {
                let params = {
                    asinCode: this.pageParams.asinCode,
                    asinType: this.pageParams.asinType,
                    consumeDay: this.storageAnalysisGetSmart.consumeDay, // 日均消耗天数
                    customQuantity: null, // 自定义消耗量
                    countryIds: this.pageParams.countryData.countryIds, //国家编码集合
                    marketIds: this.pageParams.countryData.marketIds, //店铺id集合
                }
                if (this.storageAnalysisGetSmart.consumeDay == 0) {
                    params.customQuantity = this.storageAnalysisGetSmart.consumeQuantity
                }
                return params
            },
            // 改变模目标库存量
            inputQuantity() {
                this.storageAnalysisGetSmart.targetStorageQuantity = Number(this.storageAnalysisGetSmart.targetStorageDay) * Number(this.storageAnalysisGetSmart.consumeQuantity)
            },
            // 物流方式
            changeTransport() {
                this.storageAnalysisUpdateSmart()
                this.drawZoom()
            },
            // 目标库存量改变
            changeTargetStorageQuantity() {
                // TODO 改变红绿线的目标库存量
                this.storageAnalysisUpdateSmart()
                this.drawZoom()
            },
            // 目标库存天数改变
            changeTargetStorageDay() {
                this.inputQuantity()
                this.storageAnalysisUpdateSmart()
                this.drawZoom()
            },
            inputSafeStorageDay() {
                this.storageAnalysisGetSmart.safeStorageQuantity =  Number(this.storageAnalysisGetSmart.consumeQuantity) * Number(this.storageAnalysisGetSmart.safeStorageDay)// 安全库存量
            },
            changeEstimateSafeStorageDay() {
                this.storageAnalysisUpdateSmart() // 更新计算表单信息
                this.storageAnalysisAddEstimate() // 更新添加预估信息
                this.updateLineDataRow(this.estimate) // 渲染红绿线
                // this.$refs.estimateList.storageAnalysisListEstimate() // todo 刷新添加预估信息
            },
            // change改变预估日期
            changeEstimatePurchaseDeliveryDays() {
                let tableData = this.$refs.estimateList.tableData || []
                // 修改预估list的预计入库时间
                for (const iterator of tableData) {
                    let logisticsDays = 0
                    for (const item of this.transportOption) {
                        if (iterator.transportIdPrescriptionId == item.id) {
                            logisticsDays = item.text.split("-")[1]
                            logisticsDays = logisticsDays.substr(0,logisticsDays.length-1)
                        }
                    }
                    let day = Number(logisticsDays) + Number(this.storageAnalysisGetSmart.purchaseDeliveryDays)
                    let time = 86400000*day
                    let time1 = new Date(iterator.underOrderDate).getTime()
                    iterator.expectInboundDate = convertToDate(time + time1)
                }
                this.storageAnalysisUpdateSmart() // 更新计算表单信息
                this.storageAnalysisAddEstimate() // 更新添加预估信息
                this.updateLineDataRow(this.estimate) // 渲染红绿线
                // this.$refs.estimateList.storageAnalysisListEstimate() // todo 刷新添加预估信息
            },
            // 更新预估
            async storageAnalysisAddEstimate(row) {
                let tableData = this.$refs.estimateList.tableData || []
                let params = {
                    asinCode: this.pageParams.asinCode, //ASIN类型值
                    asinType: this.pageParams.asinType, //ASIN类型（子asin：child，父asin：parent）
                    addList: tableData
                }
                let res = await storageAnalysisAddEstimate(params)
            },
            // 日均切换单独
            changeAverage(val) {
                if (val == 0) {return;}
                this.storageAnalysisUpdateSmart()
                this.storageAnalysisSmartReplenishment()
            },
            // 自定义日均change
            changeQuantity() {
                this.inputQuantity()
                this.storageAnalysisUpdateSmart()
                this.storageAnalysisSmartReplenishment()
            },
            // 预估change
            estimateChange() {
                this.updateLineDataRow(this.estimate)
            }
        },
        created() {
            this.getTransportSelect()
            this.getStorageAnalysisGetSmart()
        },
        components: {
            OptionCard,
            InventoryDetails,
            InventoryAccepted,
            DocumentDetails,
            DetailsShipment,
            InventorySummary,
            EstimateList
        }
    }
</script>

<style lang="scss" scoped>
.col-line {
    border-right: 1px solid #eee;
}
.add-estimate {
    .add {
        display: flex;
        justify-content: flex-end;
    }
    .delete {
        padding-top: 5px;
    }
    .sign-form {
        /deep/.el-form-item__label {
            width: 86px;
            padding-left: 12px;
        }
    }
}
.stock-analysis {
    .average-per-day {
        .el-select {
            /deep/.is-focus {
                .el-input__inner {
                    border-right: 1px solid #1F6EEF;
                }
            }
            /deep/.el-input__inner {
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
                border-right: 0;
            }
        }
        .el-input {
            /deep/.el-input__inner {
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
            }
        }
    }
    .form-line-table {
        border: 1px solid #eee;
        padding: 20px 10px;
        border-radius: 5px;
        .form-storage {
            padding-top: 30px;
        }
    }
    /deep/.stock-tabs {
        padding: 0;
        .tabs-content {
            border: none;
        }
        .tabs {
            font-size: 12px;
            border: 1px solid #DCDFE6;
            border-right: 0;
            padding: 9px 15px;
            line-height: 1;
            color: #606266;
            margin-top: 15px;
            &:last-of-type {
                border-right: 1px solid #DCDFE6;
                border-top-right-radius: 2px;
                border-bottom-right-radius: 2px;
            }
            &:first-of-type {
                border-top-left-radius: 2px;
                border-bottom-left-radius: 2px;
            }
            &.tabs--color {
                color: #1F6EEF;
                font-weight: bold;
                border: 1px solid #1F6EEF;
            }
        }
        .layout {
            padding: 0;
            box-shadow: none;
        }
        .tabs-content {
            padding-bottom: 12px;
        }
    }
    /deep/.el-form {
        // padding-left: 17px;
        // width: 500px;
        // overflow: auto;
    }
    /deep/.el-form-item {
        margin-bottom: 20px;
    }
    /deep/.el-form-item__label {
        width: 100px;
        text-align-last: left !important;
    }
}
</style>
